import { checkNum } from './checkNum';
import { transferNumber } from './transferNumber';

/**
 * 构造定位样式对象
 * @param {*} position
 * @returns
 */
export function buildPositionStyle(position) {
    const style = {};
    if (checkNum(position.top)) {
        style.top = `${transferNumber(position.top)}vw`;
    }
    if (checkNum(position.bottom)) {
        style.bottom = `${transferNumber(position.bottom)}vw`;
    }
    if (checkNum(position.left)) {
        style.left = `${transferNumber(position.left)}vw`;
    }
    if (checkNum(position.right)) {
        style.right = `${transferNumber(position.right)}vw`;
    }
    return style;
}
